var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMoneta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5234 4.08803L13.5 8.176L9.47656 4.08803L13.5 6.10352e-05L17.5234 4.08803Z",
    fill: "#41BA77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8887 5.52311L12.1799 4.21112L13.5322 5.58508L13.4996 8.176L10.8887 5.52311Z",
    fill: "#399B6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 0L13.5325 5.58502L14.8681 4.22801L16.1268 5.50695L17.5234 4.08797L13.5 0Z",
    fill: "#399B6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73828 8.90242L6.74996 10.9464L8.76165 8.90242L10.7733 10.9464L12.7851 8.90242L8.76165 4.81445L4.73828 8.90242Z",
    fill: "#41BA77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73828 8.90238L6.79361 8.89596L8.72215 6.93646L8.76165 8.90238L6.74996 10.9464L4.73828 8.90238Z",
    fill: "#399B6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76216 4.81439L8.72266 6.93644L10.7288 8.97487L10.7738 10.9463L12.7855 8.90236L8.76216 4.81439Z",
    fill: "#399B6F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7168L1.43464 15.1744L4.02337 12.544L6.61218 15.1744L8.04683 13.7168L4.02337 9.62878L0 13.7168Z",
    fill: "#41BA77"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7167L1.45679 13.7103L4.00602 11.1201L4.02337 12.544L1.43464 15.1744L0 13.7167Z",
    fill: "#399B6F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02321 9.62872L4.00586 11.1201L6.60495 13.761V15.1744L8.04308 13.7131L4.02321 9.62872Z",
    fill: "#399B6F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47656 13.7168L10.9056 15.1688L13.4999 12.5327L16.0943 15.1688L17.5234 13.7168L13.4999 9.62878L9.47656 13.7168Z",
    fill: "#41BA77"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47656 13.7167L10.9056 13.7159L13.4937 11.0863V12.5327L10.9025 15.1656L9.47656 13.7167Z",
    fill: "#399B6F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4995 9.62872L13.4932 11.0864L16.1034 13.7385V15.1687L17.5277 13.7216L13.4995 9.62872Z",
    fill: "#399B6F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73828 18.5311L5.85701 19.6678L8.75891 16.7193L11.6635 19.6706L12.7851 18.5311L8.76165 14.4432L4.73828 18.5311Z",
    fill: "#41BA77"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73828 18.5311L5.84033 18.5247L8.72771 15.5911L8.75891 16.7193L5.85701 19.6678L4.73828 18.5311Z",
    fill: "#399B6F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76157 14.4431L8.72754 15.591L11.6814 18.5923L11.6635 19.6706L12.7849 18.5311L8.76157 14.4431Z",
    fill: "#399B6F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47656 23.3455L10.1128 23.992L13.4999 20.5504L16.8871 23.992L17.5234 23.3455L13.4999 19.2576L9.47656 23.3455Z",
    fill: "#41BA77"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1193_19242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 5,
    height: 5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47656 19.8931H13.5159V24H9.47656V19.8931Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1193_19242)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47656 23.3455L10.1685 23.2941L13.5159 19.8931V20.5504L10.1207 24L9.47656 23.3455Z",
    fill: "#399B6F"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 19.2575L13.5159 19.8931L16.8743 23.3053L16.8872 23.9919L17.5234 23.3455L13.5 19.2575Z",
    fill: "#399B6F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2148 18.5312L15.3169 19.6509L18.2382 16.6828L21.1595 19.651L22.2617 18.5312L18.2382 14.4432L14.2148 18.5312Z",
    fill: "#41BA77"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2148 18.5311L15.3225 18.5191L18.232 15.5629L18.2382 16.6827L15.3169 19.6508L14.2148 18.5311Z",
    fill: "#399B6F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2378 14.4431L18.2314 15.563L21.1742 18.5529L21.1591 19.6509L22.2611 18.5311L18.2378 14.4431Z",
    fill: "#399B6F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9531 13.7168L20.3766 15.1631L22.9765 12.5215L25.5763 15.1631L26.9999 13.7168L22.9765 9.62878L18.9531 13.7168Z",
    fill: "#41BA77"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9531 13.7167L20.3988 13.7103L22.998 11.0695L22.9765 12.5215L20.3766 15.1631L18.9531 13.7167Z",
    fill: "#399B6F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9766 9.62872L22.998 11.0694L25.6082 13.7216L25.5764 15.1631L26.9999 13.7167L22.9766 9.62872Z",
    fill: "#399B6F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2618 10.9766L18.2409 8.96568L20.2202 10.9766L22.2616 8.90236L18.2382 4.81439L14.2148 8.90236L16.2618 10.9766Z",
    fill: "#41BA77"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.232 6.93646L16.2979 8.90162L14.2148 8.90238L16.2619 10.9766L18.241 8.9656L18.232 6.93646Z",
    fill: "#399B6F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2387 4.81439L18.2324 6.93644L20.1776 8.9129L20.2207 10.9766L22.2621 8.90236L18.2387 4.81439Z",
    fill: "#359C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMoneta);
export default __webpack_public_path__ + "static/media/logo-moneta.490a8c96625127d9d5319a4a481bb7c7.svg";
export { ForwardRef as ReactComponent };